import * as React from 'react';
import MUITooltip from '@mui/material/Tooltip';
import cn from 'classnames';

import { TooltipProps } from './types';
import { useTheme } from '../../theme';
import { SafeHtml } from '@shared/ui';

const Tooltip: React.FC<TooltipProps> = ({
	title,
	children,
	titleClassName,
	tooltipClassName,
	popperClassName,
	arrowClassName,
	placement = 'top',
	PopperProps,
	...restProps
}) => {
	const { Tooltip: css } = useTheme('BaseComponents');

	const titleClasses = cn(css.title, titleClassName);

	const titleElement =
		typeof title === 'string' ? (
			<SafeHtml tag="span" className={titleClasses} html={title} />
		) : (
			<span className={titleClasses}>{title}</span>
		);

	return (
		<MUITooltip
			title={titleElement}
			placement={placement}
			arrow={true}
			PopperProps={PopperProps}
			classes={{
				tooltip: cn(css.tooltip, tooltipClassName),
				popper: cn(css.popper, popperClassName),
				arrow: cn(css.tooltip_arrow, arrowClassName)
			}}
			{...restProps}
		>
			{children}
		</MUITooltip>
	);
};

export default Tooltip;
